export type Media = {
  id?: number | string;
  url: string;
  content_type?: string | null;
  download_url?: string | null;
};

export function isVideo(media: Media): boolean {
  return (
    (media.content_type?.startsWith('video/') ?? false) || /\.(mp4|webm|ogg)$/i.test(media.url)
  );
}
